import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Section } from '../../../../types';
import DroppableQuestionsList from './DroppableQuestionsList';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsEditingAnyQuestion } from '../../../../../../redux/questionnaire/selectors';
import { addEmptyQuestionToSection } from '../../../../../../redux/questionnaire/actions';
import styled from 'styled-components';
import { Button } from '@material-ui/core';

interface DraggableSectionContainerProps {
  section: Section;
  index: number;
  questions: any[];
}

const SectionContainer = styled.div`
  margin-bottom: 32px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
`;

const SectionHeader = styled.div`
  background-color: #f5f5f5;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 600;
  font-size: 16px;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SectionQuestions = styled.div`
  background-color: white;
`;

const DragHandle = styled.div`
  cursor: grab;
  padding: 8px;
  display: flex;
  align-items: center;
  color: #666;

  &:hover {
    color: #333;
  }

  &:active {
    cursor: grabbing;
  }
`;

function DraggableSectionContainer({ section, index, questions }: DraggableSectionContainerProps) {
  const isEditingAnyQuestion = useSelector(selectIsEditingAnyQuestion);
  const dispatch = useDispatch();

  const handleAddQuestionToSection = (sectionNumber: number) => {
    dispatch(addEmptyQuestionToSection(sectionNumber));
  };

  return (
    <Draggable draggableId={`section-${section.section}`} index={index} isDragDisabled={isEditingAnyQuestion}>
      {(provided, snapshot) => (
        <SectionContainer
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            ...provided.draggableProps.style,
            opacity: snapshot.isDragging ? 0.8 : 1
          }}
        >
          <SectionHeader {...provided.dragHandleProps}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '16px' }}>
                Question {section.section}
                {section.title && ` - ${section.title}`}
              </div>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                Each question is displayed per page
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {!isEditingAnyQuestion && (
                <Button
                  size="small"
                  style={{ backgroundColor: '#4DB181', color: 'white' }}
                  variant="contained"
                  onClick={() => handleAddQuestionToSection(section.section)}
                >
                  + Add Question
                </Button>
              )}
              <DragHandle>
                <span>⋮⋮</span>
              </DragHandle>
            </div>
          </SectionHeader>
          <SectionQuestions>
            <DroppableQuestionsList
              questions={questions}
              sections={[section]}
              droppableProvided={null}
              sectionId={`section-${section.section}-questions`}
            />
          </SectionQuestions>
        </SectionContainer>
      )}
    </Draggable>
  );
}

export default DraggableSectionContainer;
